import { z } from 'zod';
import { PHONE_MIN_LENGTH, PHONE_MAX_LENGTH } from '../../constant/phone';

export const ecosystemIntegratorSchema = z.object({
    ecosystemIntegratorName: z.string().min(1, { message: "Ecosystem Integrator is required" }),
    countryId: z.string().min(1, { message: "Country is required" }).or(z.number()),
    countryCode: z.string().min(1, { message: "County Code is required" }),
    integratorType: z.string().min(1, { message: "Integrator Type is required" }),
    email: z.string()
        .min(1, { message: 'Email is required' })
        .email({ message: 'Invalid email format' }),
    phoneNumber: z
        .string()
        .min(1, { message: "Phone Number is required" })
        .regex(
            new RegExp(`^\\d{${PHONE_MIN_LENGTH},${PHONE_MAX_LENGTH}}$`),
            { message: `Phone Number must be between ${PHONE_MIN_LENGTH} and ${PHONE_MAX_LENGTH} digits` }
        ),
    // Open (true) vs closed (false) partnership-farming ecosystem — drives the eK Acre Growth
    // "Manage Partner" / "Engage with Partners" tab visibility (EKU-224). Optional; defaults to
    // closed. Kept in the schema so zodResolver passes it through to the submit payload.
    isOpen: z.boolean().optional(),
    appUrl: z.string().max(500, { message: 'Redirect URL must be 500 characters or fewer' }).optional(),
    // The Initiative a new Initiative Based integrator serves; required for that type on create
    // (checked in the form, which knows whether it is creating).
    initiativeId: z.string().optional(),
}).superRefine((data, ctx) => {
    if (data.integratorType !== 'INITIATIVE_BASED' && data.integratorType !== 'FINANCE_BASED') return;
    const url = (data.appUrl || '').trim();
    if (!url) return;
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['appUrl'],
            message: 'Enter a full URL starting with http:// or https://',
        });
    }
});
